import React, { FC } from 'react';

import { Flex, Grid, GridItem } from '@chakra-ui/react';

import NavBar from '../NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import { PX_APP_LAYOUT, Z_INDEX } from '../../assets/themes/base/space';
import { SIZES } from '../../assets/themes/base/sizes';

interface LayoutProps {
  hasSecondaryNav?: boolean;
  children: React.ReactNode;
}

const PageLayout: FC<LayoutProps> = (props) => {
  return (
    <Flex align='center' justify='center' bg={'white'}>
      <Grid
        templateAreas={`"header header"
                  "main main"
                  "footer footer"`}
        gridTemplateRows={`${SIZES.H_TOP_NAV} 1fr auto`}
        gridTemplateColumns={'1fr'}
        h='100vh'
        w='100vw'
        bg='white'
      >
        <GridItem
          area={'header'}
          position='fixed'
          w='100%'
          zIndex={Z_INDEX.TOP_NAV}
          bg='white'
        >
          <NavBar></NavBar>
        </GridItem>
        <GridItem
          area={'main'}
          w='100%'
          maxW={SIZES.MAX_W_PAGE}
          mx='auto'
          overflowY={'auto'}
          sx={{
            scrollbarGutter: 'stable',
          }}
          px={PX_APP_LAYOUT}
          bg={'white'}
        >
          {props.children}
        </GridItem>
        <GridItem area={'footer'}>
          <Footer></Footer>
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default PageLayout;
